import React from 'react';
import { ImageProps } from '.';

const SvgCreditCardJcb = ({ size = 48, ...props }: ImageProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={(size && Math.floor(size / 1.263157894736842)) || 38}
      fill='none'
      viewBox='0 0 48 38'
      {...props}
    >
      <rect width={47} height={37} x={0.5} y={0.5} fill='#fff' stroke='#E2E5E6' rx={7.5} />
      <path
        fill='url(#CreditCardJCB_svg__a)'
        d='M30.833 19.364c.731.014 1.467-.028 2.196.023.737.122.915 1.116.26 1.442-.447.215-.979.08-1.464.118h-.992v-1.583Zm2.619-1.79c.162.51-.39.968-.943.898h-1.676c.012-.482-.023-1.004.017-1.46.671.016 1.349-.035 2.016.026.287.064.527.274.586.535ZM37.484 10c.032.975.005 2.002.014 2.997-.002 4.045.004 8.09-.004 12.135-.03 1.516-1.538 2.834-3.23 2.864-1.693.006-3.386 0-5.08.002v-6.115c1.846-.009 3.691.017 5.535-.013.856-.048 1.793-.55 1.833-1.388.1-.842-.79-1.424-1.637-1.516-.326-.007-.316-.084 0-.118.807-.155 1.44-.899 1.203-1.644-.202-.783-1.175-1.086-1.984-1.085-1.65-.01-3.3-.001-4.949-.004.01-1.142-.022-2.284.018-3.425.13-1.489 1.678-2.717 3.345-2.69h4.936Z'
      />
      <path
        fill='url(#CreditCardJCB_svg__b)'
        d='M10.544 12.845c.042-1.514 1.558-2.82 3.247-2.842 1.687-.005 3.373-.001 5.06-.002-.004 5.064.01 10.129-.007 15.193-.065 1.495-1.564 2.777-3.235 2.803-1.69.006-3.38 0-5.07.002v-6.321c1.642.345 3.363.492 5.038.263 1-.143 2.096-.581 2.435-1.505.25-.791.109-1.623.146-2.435v-1.885H15.26c-.013 1.247.027 2.495-.021 3.74-.078.766-.93 1.252-1.74 1.226-1.006.01-2.998-.649-2.998-.649-.005-2.335.029-5.26.043-7.588Z'
      />
      <path
        fill='url(#CreditCardJCB_svg__c)'
        d='M19.932 16.876c-.153.03-.03-.462-.07-.649.01-1.178-.021-2.358.018-3.536.13-1.495 1.69-2.725 3.364-2.69h4.93c-.004 5.064.01 10.129-.006 15.193-.066 1.495-1.565 2.777-3.236 2.803-1.69.006-3.38.001-5.07.003v-6.927c1.154.843 2.723.974 4.161.977 1.084 0 2.162-.15 3.215-.372V20.41c-1.187.527-2.581.86-3.896.559-.918-.204-1.584-.993-1.57-1.836-.105-.876.472-1.802 1.44-2.062 1.2-.335 2.51-.079 3.636.356.241.113.486.252.39-.107v-.997c-1.884-.399-3.888-.546-5.78-.112-.548.138-1.081.346-1.526.666Z'
      />
      <defs>
        <linearGradient
          id='CreditCardJCB_svg__a'
          x1={29.128}
          x2={37.445}
          y1={18.615}
          y2={18.615}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#58B03A' />
          <stop offset={1} stopColor='#55B330' />
        </linearGradient>
        <linearGradient
          id='CreditCardJCB_svg__b'
          x1={10.363}
          x2={18.715}
          y1={19.172}
          y2={19.172}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0F6EB6' />
          <stop offset={1} stopColor='#006DBA' />
        </linearGradient>
        <linearGradient
          id='CreditCardJCB_svg__c'
          x1={19.85}
          x2={28.173}
          y1={18.79}
          y2={18.79}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#DE0D3D' />
          <stop offset={1} stopColor='#E30138' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SvgCreditCardJcb;
